module.exports = __webpack_public_path__ + "img/mail-opened.dc7e2607.svg";